export default __webpack_public_path__ + "static/SV-soc-centrai-6e96a2b6aaaa7c0094a61b1753ce4068.png";